export default "__VITE_ASSET__55a8a14d__"